module.exports = __webpack_public_path__ + "static/UIPath-abf061a95a1dc2ce1fdafbc88b4a2fd6.jpg";